<template>
  <v-container
    fluid
    class="rbu-section-detail"
    v-if="section"
    id="rbu-extra-item-pdf"
  >
    <v-row class="flex-grow-0">
      <v-btn
        text
        color="primary"
        exact
        :to="{
          name: 'rbu-section-detail',
          params: { sectionId: section.id },
        }"
      >
        <h3 class="font-weight-regular">
          &lt;&lt; {{ section.order_no }}. {{ section.name }}
        </h3>
      </v-btn>
    </v-row>

    <v-row class="rbu-section-info-wrapper">
      <h3>Extra handle for Items - {{ section.name }}</h3>
      <v-spacer></v-spacer>
      <v-btn color="primary" class="ml-4 hidden-pdf-button" small @click="save">
        SAVE
      </v-btn>
      <v-btn
        color="primary"
        class="ml-4 hidden-pdf-button"
        small
        @click="exportPDF"
        :disabled="export_loading"
      >
        EXPORT AS PDF
      </v-btn>
    </v-row>

    <div
      class="rbu-extra-item-card-content"
      style="margin-top: 2rem; zoom: 85%"
    >
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="rbu-extra-item-column-order"></th>
              <th class="rbu-extra-item-column-dum-no">Dummy item No</th>
              <th class="rbu-extra-item-column-type">Type</th>
              <th class="rbu-extra-item-column-index">#</th>

              <th class="rbu-extra-item-column-item-descriptions">
                Item Descriptions
              </th>
              <th class="rbu-extra-item-column-reference">Reference</th>
              <th class="rbu-extra-item-column-value">Value</th>
              <th class="rbu-extra-item-column-formula">Formula</th>
              <th class="rbu-extra-item-column-description">Remarks</th>
              <th class="rbu-extra-item-column-actions">Action</th>
            </tr>
          </thead>
          <tbody>
            <RbuExtraItemRow
              v-for="(item, idx) in items"
              :key="idx"
              :item="item"
              :idx="idx"
              :total="items.length"
              @update="updateItem(idx, $event)"
              @delete="deleteItem($event)"
              @up="swapItemOrder(idx, idx - 1)"
              @down="swapItemOrder(idx, idx + 1)"
            ></RbuExtraItemRow>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <div style="margin-top: 1rem">
      <v-btn color="primary" class="hidden-pdf-button" small @click="addItem">
        Add
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { ACTION_TYPES } from "@/store/types";
import { onMounted, ref, watch } from "@vue/composition-api";
import RbuExtraItemRow from "@/components/rbu/RbuExtraItemRow.vue";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export default {
  name: "RbuItemExtra",
  components: {
    RbuExtraItemRow,
  },
  setup(props, { root, emit }) {
    const section = ref(null);
    const items = ref([]);
    const export_loading = ref(false);

    const getSection = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/section/",
        params: { section_id: root.$route.params.rbu_item_extra_section_id },
      });

      if (response.body.success) {
        section.value = response.body.section;
      }
    };

    const addItem = async function () {
      const init_data = {
        dummy_item_no: "",
        type: "",
        formula: "",
        descriptions: "",
        value: 0,
        order: items.value.length,
      };
      items.value = [...items.value, init_data];
    };

    const swapItemOrder = async function (itemAIndex, itemBIndex) {
      // Check if the indexes are within the bounds of the array
      if (
        itemAIndex < 0 ||
        itemBIndex < 0 ||
        itemAIndex >= items.value.length ||
        itemBIndex >= items.value.length
      ) {
        console.log("Out OF Index");
        return;
      }

      // Swap the items in the array
      const newItems = [...items.value];
      [newItems[itemAIndex], newItems[itemBIndex]] = [
        newItems[itemBIndex],
        newItems[itemAIndex],
      ];
      items.value = newItems; // Replace the old array with the new one
    };

    const updateItem = async function (index, updatedItem) {
      const original = items.value[index];
      items.value.splice(index, 1, { ...original, ...updatedItem });
    };

    const deleteItem = async function (index) {
      items.value.splice(index, 1);
    };

    const exportPDF = async function () {
      await save();

      export_loading.value = true;

      try {
        let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/rbu/section/generate_extra_pdf/",
          params: {
            section_id: section.value.id,
          },
          opt: { extra: { responseType: "arraybuffer" } },
        });

        let blob = new Blob([response.data], {
          type: response.headers.get("content-type"),
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = decodeURI(response.headers.get("content-filename"));
        link.click();
      } catch (e) {
        console.log(e);
      } finally {
        export_loading.value = false;
      }
    };

    const save = async function () {
      // validate the data
      let error_msg = "";
      let itemNoSet = new Set();

      for (const [i, item] of items.value.entries()) {
        // file
        if (item.file) {
          const file =
            item.file instanceof File
              ? await root.$convertFileToBase64(item.file)
              : item.file.id;

          const filename = item.file instanceof File ? item.file.name : null;
          item.file = file;
          item.filename = filename;
        } else {
          item.file = null;
        }

        // dummy_item_no
        if (!item.dummy_item_no) {
          error_msg += `#${i + 1} - Please fill in the dummy item no.\n`;
        } else {
          // check regex
          if (!item.dummy_item_no.match(/.*[A-L]$/g)) {
            error_msg += `#${i + 1} - Dummy item no. '${
              item.dummy_item_no
            }' must ends with [A-L]\n`;
          }
          // Check for duplicates
          if (itemNoSet.has(item.dummy_item_no)) {
            error_msg += `#${i + 1} - Duplicate dummy item no. '${
              item.dummy_item_no
            }'\n`;
          } else {
            itemNoSet.add(item.dummy_item_no);
          }
        }

        // type
        if (!item.type) {
          error_msg += `#${i + 1} - Please select the type.\n`;
        }
      }

      if (error_msg) {
        alert(error_msg);
        return;
      }

      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/extra_item/save/",
        params: {
          section_id: root.$route.params.rbu_item_extra_section_id,
          items: items.value,
        },
      });

      if (response.body.success) {
        getSectionItemExtra();
      }
    };

    const getSectionItemExtra = async () => {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/rbu/extra_item/",
        params: { section_id: root.$route.params.rbu_item_extra_section_id },
      });

      if (response.body.success) {
        items.value = response.body.extra_items;
      }
    };

    onMounted(() => {
      getSection();
      getSectionItemExtra();
    });

    return {
      section,
      addItem,
      exportPDF,
      updateItem,
      deleteItem,
      items,
      save,
      export_loading,
      swapItemOrder,
    };
  },
};
</script>

<style lang="scss">
.rbu-extra-item-card-content {
  display: flex;
  flex-direction: column;
  padding: 8px 0;

  thead {
    background: rgba(0, 0, 0, 0.1);
  }
  .rbu-extra-item-column-order {
    width: 2%;
  }

  .rbu-extra-item-column-dum-no {
    width: 9%;
  }

  .rbu-extra-item-column-type {
    width: 10%;
  }
  .rbu-extra-item-column-item-descriptions {
    width: 10%;
  }

  .rbu-extra-item-column-reference {
    width: 10%;
  }

  .rbu-extra-item-column-index {
    width: 5%;
  }

  .rbu-extra-item-column-value {
    width: 10%;
  }

  .rbu-extra-item-column-formula {
    width: 15%;
  }

  .rbu-extra-item-column-description {
    width: 15%;
  }
  .rbu-extra-item-column-action {
    width: 15%;
  }
}
</style>
